import RenderComponent from '@/modules/DynamicRenderPage';
import { COOKIE_AUTH_DETAILS } from 'globalconfig/constants/keys';
import AuthContext from 'globalservices/auth';
import { deleteCookie } from 'globalservices/cookie';
import { loadPageConfig, loadStyle } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy, useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ParentStyled from './style';
import { getRedirectionURL, handleLoginWithToken } from './utils/loginHelpers';

let Styled = loadStyle(ParentStyled, 'pages/web/Login');
const config = loadPageConfig();
const Content = lazy(() => import(`@/${config.login[0].name}`));

const Login = ({ history, i18n, fetchLogin, clearRedux, ...rest }) => {
  const auth = useContext(AuthContext);
  const [redirectedFromFleetops, setRedirectedFromFleetops] = useState(null);
  const [redirectedUrl, setRedirectedUrl] = useState(null);

  const commonParentProps = { history, Styled, i18n };

  useEffect(() => {
    if (auth?.auth) {
      if ((window.$environment.SERVICE_PROVIDER === 'spireon' ||
        window.$environment.SERVICE_PROVIDER === "nauto") &&
        history.location.state?.search) {
        deleteCookie(COOKIE_AUTH_DETAILS);
        clearRedux();
      } else {
        const redirectionURL = getRedirectionURL(history.location?.search, 'redirect');
        if (redirectionURL && redirectionURL.includes(window.$environment?.FLEETOPS_URL)) {
          setRedirectedFromFleetops(redirectionURL);
        } else {
          history.push(window.$environment.CURRENT_LAYOUT === 'SpireonNew' ? history.location.state?.referrer : '/');
        }
      }
    }
  }, [auth, history, clearRedux]);

  useEffect(() => {
    const redirectionURL = getRedirectionURL(history.location?.search, 'redirect');
    if (history.location.state?.search &&
      (window.$environment.SERVICE_PROVIDER === 'spireon' ||
        window.$environment.SERVICE_PROVIDER === 'nauto')) {
      handleLoginWithToken(history, fetchLogin, clearRedux, COOKIE_AUTH_DETAILS);
    } else if (redirectionURL && redirectionURL.includes(window.$environment?.FLEETOPS_URL)) {
      setRedirectedFromFleetops(redirectionURL);
    } else if (redirectionURL) {
      setRedirectedUrl(history.location?.search.replace('?redirect=', ''));
    }
  }, [history, fetchLogin, clearRedux]);

  if (history.location.state?.search && window.$environment.SERVICE_PROVIDER === 'spireon') {
    return null;
  }

  return (
    <RenderComponent
      {...config.login[0]}
      parentProps={{ history, i18n, fetchLogin, clearRedux }}
      commonParentProps={commonParentProps}
      component={Content}
      redirectedFromFleetops={redirectedFromFleetops}
      redirectedUrl={redirectedUrl}
      {...rest}
    />
  );
};

const mapState = (state) => ({
  apiStatus: state.asyncRequests,
  login: state.login,
});

const mapDispatch = (dispatch) => ({
  fetchLogin: (data) => dispatch.login.fetchData(data),
  clearRedux: () => dispatch({ type: 'RESET_APP' }),
});

Login.propTypes = {
  login: PropTypes.object.isRequired,
  apiStatus: PropTypes.object.isRequired,
  fetchLogin: PropTypes.func.isRequired,
  clearRedux: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired,
};

export default connect(mapState, mapDispatch)(Login);
